import DisplayData from "../common/DisplayData/DisplayData";
import { TokenHelper } from "../../assets/utils/helpers";
import Drawer from "../../assets/vfx/drawer/drawer";
import { LoadingIndicator } from "../../assets/vfx/loadingIndicator/vfxLoadingIndicator";
import { LookupDto } from "../../assets/utils/lib/lookupDto";
import { UserService } from "../account/user/userService";

interface ProfileViewProps {
    show: boolean;
    onHide: () => void;
    onEdit: () => void;
}

const ProfileView = (props: ProfileViewProps) => {
    const claims = TokenHelper.getClaims();
    const userQuery = UserService.getUserQuery(claims?.user_id ?? undefined);
    const lookupQuery = UserService.getLookups();

    return (
        <>
            {(userQuery.isLoading || lookupQuery.isLoading) ? <LoadingIndicator isFullPage={true} /> :
                <Drawer.View
                    className="w-30"
                    show={props.show}
                    backdrop={true}
                    placement="end"
                    scroll={true}
                    onHide={() => props.onHide()}
                    onEdit={props.onEdit}
                    title={"View User"}
                >
                    <>
                        <DisplayData text="First Name" importedData={userQuery.data?.firstName} />
                        <DisplayData text="Last Name" importedData={userQuery.data?.lastName} />
                        <DisplayData text="Email" importedData={userQuery.data?.email} />
                        <DisplayData text="Role" importedData={LookupDto.getLookupById(lookupQuery.data?.roles, userQuery.data?.roleId)?.display} />
                        {userQuery.data?.communityId && <DisplayData text="Community" importedData={LookupDto.getLookupById(lookupQuery.data?.communities, userQuery.data?.communityId)?.display} />}
                        <DisplayData text="Phone Number" importedData={userQuery.data?.phoneNumber} />
                    </>
                </Drawer.View>
            }
        </>
    );
};

export default ProfileView;
